import { ApiMetric } from "@incendium/api";
import { useProductTrendContext } from "features/products/providers/ProductTrendProvider";
import { useEffect, useSyncExternalStore } from "react";

export function useProductTrendPoints(
  productName: string,
  trendMetric: ApiMetric,
) {
  const { requestTrend, subscribe, getSnapshot, getCacheKey } =
    useProductTrendContext();
  const cacheKey = getCacheKey(productName, trendMetric);

  useEffect(() => {
    if (productName) {
      requestTrend(productName, trendMetric);
    }
  }, [cacheKey, productName, requestTrend, trendMetric]);

  const snapshot = useSyncExternalStore(
    (onStoreChange) => subscribe(cacheKey, onStoreChange),
    () => getSnapshot(cacheKey),
    () => getSnapshot(cacheKey),
  );

  return {
    trendPoints: snapshot.points,
    loading: productName ? snapshot.loading : false,
  };
}
